require('jquery-ui-dist/jquery-ui');

import '../components/ubigeo';

$(() => {
  const inputOptionsPet = $('input[filter_form_pet]');

  // $(".filter-form").hide();
  // $(".filter-form")
  //   .filter(`.filter-form-${$("input[filter_form_pet]:checked").val()}`)
  //   .show();

  function readURL(input) {
    if (input.files && input.files[0]) {
      var reader = new FileReader();

      reader.onload = function (e) {
        $('#img-profile').attr('src', e.target.result);
      };

      reader.readAsDataURL(input.files[0]); // convert to base64 string
    }
  }

  $('#input-image').change(function () {
    readURL(this);
  });

  $('.datepicker').datepicker({
    showOtherMonths: true,
    selectOtherMonths: false,
    changeMonth: true,
    changeYear: true,
    yearRange: '-100:+0',
    dateFormat: 'dd/mm/yy',
  });

  inputOptionsPet.on('change', function (e) {
    const el = $(this);
    const value = el.val();

    const petValue = {
      1: 'dog',
      2: 'cat',
      3: 'other',
    };

    $('.filter-form').hide();
    $('.filter-form').filter(`.filter-form-${petValue[value]}`).show();
  });

  $('#select-type-dog').on('change', function (e) {
    const el = $(this);
    const value = el.val();
    const isNone = value == 'Ninguno';

    $('#input-license').attr('required', !isNone);
  });
});
